<template lang="pug">
  .map-item(v-click-outside="close")
    .map-balloon-sp.active(v-if="company")
      .map-balloon-box
        .company_name
          router-link(
            :to="{name: 'CompanyDetail', query: { id: company.id, from: 'map' }}" target="_blank")
            | {{ company.company_name }}
          .col.marking(:class="company.in_job_mark ? 'on' : ''")
            span(@click="updateJobMark") マーキング
        .company_tel
          a(:href="`tel:${companyTel}`" v-if="companyTel")
            | {{ companyTel }}
        .company_url
          a(
            :href="companyUrl"
            target="_blank"
            rel="noopener noreferrer"
            v-if="companyUrl !== '−'")
            | {{ companyUrl }}
          span(v-else)
            | {{ companyUrl }}
        .company_place
          | {{ company.company_place ? company.company_place : '−' }}
        .budget
          span 出稿予算
          ul
            li 今月：{{ company.budget_current_month }}
            li 先月：{{ company.budget_last_month }}
            li 3ヶ月：{{ company.budget_last_quarter }}
            li 6ヶ月：{{ company.budget_last_harf_year }}
            li 1年：{{ company.budget_last_year }}
        .published_media
          | 掲載：
          a(:href="company.master_url" target="_blank"
            rel="noopener noreferrer"
            v-if="company.published_media_name_all")
            | {{ company.published_media_name_all }}
          span(v-else)
            | −
      a.map-balloon-close(@click="close")
</template>

<script>
  import ClickOutside from 'vue-click-outside'

  export default {
    directives: { ClickOutside },
    props: ['company', 'companyTel', 'companyUrl'],
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      close () {
        this.$emit('close')
      },
      updateJobMark () {
        this.$emit('toggle', this.company)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/MapSpInfoWindow.vue